import { render, staticRenderFns } from "./UrlsList.vue?vue&type=template&id=1220409e&"
import script from "./UrlsList.vue?vue&type=script&lang=js&"
export * from "./UrlsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports